import * as React from "react";
import { observer } from "mobx-react";
import i18n from "i18n";
import {
  Grid,
  Button,
  Typography,
  Dialog,
  DialogContent,
  Link,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { ProfileStore } from "modules/profile/ProfileStore";
import { DevelopmentStore } from "../../DevelopmentStore";
import { insertTagsAtText } from "utils/StringUtils";

const styles = (theme) => ({
  root: {
    borderRadius: 8,
    padding: "1.5rem 5rem 2.5rem 5rem",
  },
  paper: {
    backgroundColor: "#F2F2F2 !important",
  },
  titleTrial: {
    color: "#9AAF00",
    fontWeight: 700,
    fontSize: "24px",
    marginBottom: "2.5rem",
    textAlign: "center" as any,
  },
  textTrial: {
    color: "#757575",
    fontWeight: 400,
    fontSize: "16px",
    textAlign: "center" as any,
    marginBottom: 20,
  },
  btnSign: {
    border: "none",
    backgroundColor: "#9AAF00",
    color: "#FFFFFF",
    margin: "20px 0 12px 0",
  },
});

interface IProps {
  classes: any;
}

@observer
class TrialMessage extends React.Component<IProps> {
  handleClose = () => {
    DevelopmentStore.clearTrialMessageError();
  };

  render() {
    const { classes } = this.props;

    const type = DevelopmentStore.trialMessageError;
    const open = Boolean(type);

    return (
      <Dialog
        open={open}
        onClose={this.handleClose}
        classes={{ paper: classes.paper }}
      >
        <DialogContent className={classes.root}>
          <Typography variant="h4" gutterBottom className={classes.titleTrial}>
            {i18n.trialMessage.title}
          </Typography>
          {type === "out-of-storage-space" ? (
            <>
              <Typography variant="body2" className={classes.textTrial}>
                {insertTagsAtText(i18n.trialMessage.spaceMessage)}
              </Typography>
              <Typography variant="body2" className={classes.textTrial}>
                {insertTagsAtText(i18n.trialMessage.spaceMessage2)}
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="body2" className={classes.textTrial}>
                {insertTagsAtText(i18n.trialMessage.resourceMessage)}
              </Typography>
              <Typography variant="body2" className={classes.textTrial}>
                {insertTagsAtText(i18n.trialMessage.resourceMessage2)}
              </Typography>
            </>
          )}
          <Grid container direction="row" justify="center">
            <Button
              className={classes.btnSign}
              href={ProfileStore.subscriptionLink}
              target="_blank"
            >
              {i18n.trialRegister.subscribeNow}
            </Button>
          </Grid>
          <Grid container direction="row" justify="center">
            <Link
              underline="always"
              onClick={this.handleClose}
              style={{ cursor: "pointer" }}
            >
              {i18n.trialMessage.rememberLater}
            </Link>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(styles)(TrialMessage);



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/TrialMessage.tsx